export * from './aiAgent.service';
import { AiAgentService } from './aiAgent.service';
export * from './aiAgent.serviceInterface';
export const APIS = [AiAgentService];
